import { render, staticRenderFns } from "./common-switch.vue?vue&type=template&id=cff52b0c&scoped=true"
import script from "./common-switch.vue?vue&type=script&lang=js"
export * from "./common-switch.vue?vue&type=script&lang=js"
import style0 from "./common-switch.vue?vue&type=style&index=0&id=cff52b0c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cff52b0c",
  null
  
)

export default component.exports